import { Token } from "./services/Token";

export function getApiUrl(baseUrl: string, relativeUrl: string): string {
    if (relativeUrl && !relativeUrl.startsWith("/")) {
        relativeUrl = `/${relativeUrl}`;
    }

    return baseUrl + "/api/v1" + relativeUrl;
}

export function getFormHeaders(): object {
    return { "Content-Type": "application/x-www-form-urlencoded" };
}

export function getTokenHeaders(token: Token): object {
    return token ? { Authorization: `Bearer ${token.access_token}` } : {};
}

// Necessary to stop IE from caching repeated GET requests of non-static content
export function getNoCacheHeaders(): object {
    return { "Cache-Control": "no-cache", "Pragma": "no-cache", "Expires": 0 };
}
